import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, SimpleGrid } from '@chakra-ui/react';

import ProfileHeader from './components/ProfileHeader';
import AccountSettings from './components/AccountSettings';
import ChangePassword from './components/ChangePassword';
import DeleteAccount from './components/DeleteAccount';

import { getProfileApi } from 'features/users/users.api';

const Profile = () => {
  const dispatch = useDispatch();
  const { user, userId, getProfileStatus } = useSelector((state) => state.users);

  useEffect(() => {
    if (getProfileStatus !== 'pending') {
      dispatch(getProfileApi());
    }
  }, []);

  return (
    <Box px={{ base: 4, md: 10 }} py={{ base: 6, md: 8 }} minH="100vh" mt="50px">
      <ProfileHeader user={user} />

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
        <AccountSettings user={user} userId={userId} />
        <ChangePassword />
      </SimpleGrid>

      <DeleteAccount />
    </Box>
  );
};

export default Profile;
